import { Slot } from '@magicschool/spellbook/components/Slot';
import type { SpinnerProps } from '@magicschool/spellbook/components/Spinner';
import { Spinner } from '@magicschool/spellbook/components/Spinner';
import { getControlIconSize } from '@magicschool/spellbook/lib/controls';

export const ToggleIconButtonSpinnerSlot = Slot<SpinnerProps>({
  displayName: 'ToggleIconButton.Spinner',
  isRenderedByDefault: true,
  renderDefault: ({ size: providedSize, ...props }) => {
    const size = getControlIconSize(providedSize);
    return <Spinner data-spellbook-name="toggle-icon-button-spinner" size={size} {...props} />;
  },
});
